<template>
  <div class="navigation-tag">
    <div class="close-all-tag-wrapper">
      <Dropdown transfer @on-click="handleTagsOption">
        <Button size="small" type="text">
          <Icon :size="18" type="ios-close-circle-outline" />
        </Button>
        <DropdownMenu slot="list">
          <!-- <DropdownItem name="clearAll">关闭所有</DropdownItem>
          <DropdownItem name="clearOthers">关闭其他</DropdownItem>-->
          <DropdownItem
            v-for="(value, key) of dropdownList"
            :name="key"
            :key="`dropDownItem-${key}`"
            >{{ value }}</DropdownItem
          >
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="btn-wrapper left-btn">
      <Button type="text" @click="handleScroll(240)">
        <Icon :size="18" type="ios-arrow-back" />
      </Button>
    </div>
    <div class="btn-wrapper right-btn">
      <Button type="text" @click="handleScroll(-240)">
        <Icon :size="18" type="ios-arrow-forward" />
      </Button>
    </div>

    <div
      ref="scrollOuter"
      @DOMMouseScroll="handlescroll"
      @mousewheel="handlescroll"
      class="scroll-outer"
    >
      <div
        ref="scrollBody"
        class="scroll-body"
        :style="{ left: tagBodyLeft + 'px' }"
      >
        <transition-group name="taglist-moving-animation">
          <Tag
            type="dot"
            v-for="(item, index) in headerNavigationTagList"
            ref="tagsPageOpened"
            :key="`tag-nav-${index}`"
            :name="item.name"
            :closable="item.name !== 'home'"
            :color="
              item.children
                ? item.children[0].name === currentPageName
                  ? 'primary'
                  : 'default'
                : item.name === currentPageName
                ? 'primary'
                : 'default'
            "
            @on-close="handleClose(item)"
            @click.native="handleClick(item)"
            >{{ showTitle(item) }}</Tag
          >
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { routeEqual } from '../menu-util';

export default {
  name: 'HeaderNavigationTag',
  data() {
    return {
      currentPageName: this.$route.name,
      tagBodyLeft: 0,
      refsTag: [],
      tagsCount: 1,
      dropdownList: {
        all: '关闭所有',
        others: '关闭其他',
      },
    };
  },
  props: {
    currentRoute: Object, // 当前路由
    headerNavigationTagList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    // 动态计算当前路由对象
    currentRouteObj() {
      const { name, params, query } = this.currentRoute;
      return { name, params, query };
    },
  },
  methods: {
    showTitle(item) {
      return (item.meta && item.meta.title) || item.name;
    },

    // 关闭标签
    handleClose(current) {
      // 过滤出不匹配 current 路由信息对象的 route list
      let result = this.headerNavigationTagList.filter(
        (item) => !routeEqual(current, item),
      );
      this.$emit('on-close-tag', result, undefined, current);
    },

    handleClick(item) {
      this.$emit('toLink', item);
    },

    handleScroll(offset) {
      const outerWidth = this.$refs.scrollOuter.offsetWidth;
      const bodyWidth = this.$refs.scrollBody.offsetWidth;
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset);
      } else {
        if (outerWidth < bodyWidth) {
          if (this.tagBodyLeft >= -(bodyWidth - outerWidth)) {
            this.tagBodyLeft = Math.max(
              this.tagBodyLeft + offset,
              outerWidth - bodyWidth,
            );
          }
        } else {
          this.tagBodyLeft = 0;
        }
      }
    },

    handlescroll(event_) {
      var type = event_.type;
      let delta = 0;
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = event_.wheelDelta
          ? event_.wheelDelta
          : -(event_.detail || 0) * 40;
      }
      this.handleScroll(delta);
    },

    // 关闭标签功能
    handleTagsOption(type) {
      // 除 home，其他全部关闭
      if (type === 'all') {
        let result = this.headerNavigationTagList.filter(
          (item) => item.name === 'home',
        );
        this.$emit('on-close-tag', result, 'all');
      }

      // 除当前 tag 和 home，其他 tag 全部关闭
      if (type === 'others') {
        let result = this.headerNavigationTagList.filter(
          (item) =>
            routeEqual(this.currentRouteObj, item) || item.name === 'home',
        );

        this.$emit('on-close-tag', result, 'others', this.currentRouteObj);
      }
      this.tagBodyLeft = 0;
    },

    moveToView(tag) {
      if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + 10;
      } else if (
        tag.offsetLeft + 10 > -this.tagBodyLeft &&
        tag.offsetLeft + tag.offsetWidth <
          -this.tagBodyLeft + this.$refs.scrollCon.offsetWidth - 100
      ) {
        // 标签在可视区域
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(
          tag.offsetLeft -
          (this.$refs.scrollCon.offsetWidth - 100 - tag.offsetWidth) +
          20
        );
      }
    },

    getTagElementByName(name) {
      this.$nextTick(() => {
        this.$refsTag = this.$refs.tagsPageOpened;
        for (const [index, item] of this.refsTag.entries()) {
          if (name === item.name) {
            let tag = this.refsTag[index].$el;
            this.moveToView(tag);
          }
        }
      });
    },
  },
  mounted() {
    // 这里不设定时器就会有偏移 bug
    setTimeout(() => {
      this.getTagElementByName(this.$route.name);
    }, 200);
    this.tagsCount = this.headerNavigationTagList.length;
  },
  watch: {
    $route(to) {
      this.currentPageName = to.name;
      this.$nextTick(() => {
        for (const [index, item] of this.refsTag.entries()) {
          if (to.name === item.name) {
            let tag = this.refsTag[index].$el;
            this.moveToView(tag);
          }
        }
      });
      this.tagsCount = this.headerNavigationTagList.length;
    },
  },
};
</script>

<style lang="less" scoped>
.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.size {
  width: 100%;
  height: 100%;
}

.navigation-tag {
  position: relative;
  // border-top: 1px solid #F0F0F0;
  // border-bottom: 1px solid #F0F0F0;
  overflow: hidden;
  // background: #f0f0f0;
  background: #f7f7f7;
  .no-select;
  .size;

  .close-all-tag-wrapper {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
    padding-top: 7px;
    text-align: center;
    width: 32px;
    height: 100%;
    background: white;
    z-index: 10;
  }

  .btn-wrapper {
    position: absolute;
    top: 0px;
    height: 100%;
    background: #fff;
    padding-top: 3px;
    z-index: 10;
    button {
      padding: 6px 4px;
      line-height: 14px;
      text-align: center;
    }
    &.left-btn {
      left: 0px;
    }
    &.right-btn {
      right: 32px;
      border-right: 1px solid #f0f0f0;
    }
  }

  .scroll-outer {
    position: absolute;
    left: 28px;
    right: 61px;
    top: 0;
    bottom: 0;
    box-shadow: 0px 0 3px 2px rgba(100, 100, 100, 0.1) inset;
    .scroll-body {
      position: absolute;
      padding: 2px 4px 0;
      overflow: visible;
      white-space: nowrap;
      transition: left 0.3s ease;
    }
  }
}
</style>
